@if (question && question.video_path) {
  @if (type === 'video/mp4') {
    <video width="100%" style="max-height:80vh;" controls>
      <source [src]="src" [type]="type">
    </video>
  }

  @if (type === 'youtube') {
    <iframe
      width="560"
      height="315"
      [src]="safeVideoUrl"
      title="Video player"
      frameborder="0"
      referrerpolicy="strict-origin-when-cross-origin"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen>
    </iframe>
}

} @else {

  <div class="video-wrapper">

    <video #videoPlayer width="100%" controls>
      <source [src]="src" [type]="type">
    </video>

    @if (videoDuration) {
      <div class="progress-hover-overlay" (mousemove)="onBarHover($event)" (mouseleave)="onBarLeave()">
      </div>
    }

    @if (videoMarkers?.length && videoDuration) {
      <div class="marker-bar" (mousemove)="onBarHover($event)" (mouseleave)="onBarLeave()">

        @if (activeMarker) {

          <div class="marker-popup" (mouseenter)="openMarker(activeMarker)" (mouseleave)="closePopup()">

            <button class="close-btn" (click)="forceClosePopup()">×</button>
            <h4>{{ activeMarker.text }}</h4>
            @if (activeMarker.description) {
              <p>{{ activeMarker.description }}</p>
            }

            @if (activeMarker.referenceCode) {
              <p><b>Reference Code:</b>{{ activeMarker.referenceCode }}</p>
            }

            @if (activeMarker.url) {
              <a [href]="activeMarker.url" target="_blank" rel="noopener noreferrer">{{ activeMarker.url }}</a>
            }

          </div>

        }
        @if (showHoverTime) {
          <div class="hover-time" [style.left.%]="hoverPosition">{{ formatTime(hoverTime) }}</div>
        }
        @for (marker of videoMarkers; track marker) {

          <div class="marker-wrapper" [style.left.%]="(marker.time / videoDuration) * 100" (mouseenter)="openMarker(marker)"
            (mouseleave)="closePopup()">

            <div class="marker-dot" (click)="seekTo(marker.time); openMarker(marker, true); $event.stopPropagation()"></div>

            <div class="marker-label">{{ marker.text }}</div>

          </div>

        }
      </div>
    }
    <div class="time-display">
      <span>{{ formatTime(currentTime) }}</span>
      <span>{{ formatTime(videoDuration) }}</span>
    </div>

  </div>
}